<template>
  <div id="app">
    <Header></Header>
    <keep-alive :include="include" :max="10">
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <qq-serve v-if="includesQQserve.indexOf($route.name) !== -1"></qq-serve>
    <!-- 部分路由不应该包含这个Footer -->
    <Footer v-if="excludeRoutes.indexOf($route.name) == -1"></Footer>
  </div>
</template>

<script>
import Header from "@/components/pc/header/Header";
import Footer from "@/components/pc/footer/Footer";
import qqServe from "@/components/pc/qqServe";
export default {
  name: "App",
  data() {
    return {
      include: [],
      // 不显示底部的页面
      excludeRoutes: [
        // "HomeIndex",
        // "MyAddress",
        // "AddAddress",
        // "MyOrder",
        // "MyShoppingCart",
        // "NotFind"
      ],
      includesQQserve: ["Index", "Patient", "GoodsDetail"]
    };
  },
  components: {
    Header,
    qqServe,
    Footer
  },
  watch: {
    $route(to) {
      console.log('PC配置')
      console.log(to)
      if (this.isKeepAlive(to) && to.name !== "Login") {
        !this.include.includes(to.name) && this.include.push(to.name);
      }
    }
  },
  methods: {
    isKeepAlive(to) {
      return to.meta.keepAlive === undefined || to.meta.keepAlive;
    }
  }
};
</script>
